import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import DashCard from '../../../app/components/DashCard';
import DashboardPageStyles from '../DashboardPageStyles';
import RainfallChart from './RainfallChart';
import { useData } from '../../../contexts/DataContext';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export default function MainContents() {
  const classes = DashboardPageStyles();
  const data = useData();
  const history = useHistory();

  const [rainfallLogCount, setRainfallLogCount] = useState(0);  
  const [usersCount, setUsersCount] = useState(0);


  useEffect(() => {
    setRainfallLogCount(data?.rainfallLogsData.length!);
  }, [data?.rainfallLogsData]);

  useEffect(() => {
    setUsersCount(data?.usersListData.length!);
  }, [data?.usersListData]);

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        {/* Chart */}
        <Grid item xs={12} md={8} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title="Users" mainText={`${usersCount}`} smallText="Users" buttonText="View All" buttonOnClick={(e) => {history.push("/admin/users")  }} />
          </Paper>
        </Grid>
        {/* Recent Deposits */}
        <Grid item xs={12} md={4} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title="Rain Level Logs" mainText={`${rainfallLogCount}`} smallText="entries" buttonText="View All" buttonOnClick={(e) => { history.push("/admin/rainfall") }} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title="River Level Logs" mainText="0" smallText="entries" buttonText="View All" buttonOnClick={(e) => { }} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title="Issues" mainText="0" smallText="issues" buttonText="View All" buttonOnClick={(e) => { }} />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paperCard}>
            <RainfallChart />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}